import script from "./leads-stages.vue?vue&type=script&setup=true&lang=js"
export * from "./leads-stages.vue?vue&type=script&setup=true&lang=js"

import "./leads-stages.vue?vue&type=style&index=0&id=453a34af&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453a34af"]])

export default __exports__